module.exports = __webpack_public_path__ + "a8f26f1f6722f5cf3781cf18bc362ecb.MP3";